import { render, staticRenderFns } from "./BlockCanvasGrid.vue?vue&type=template&id=7ea7bbb2"
import script from "./BlockCanvasGrid.vue?vue&type=script&lang=js"
export * from "./BlockCanvasGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports